import api from 'api'

import { CACHE_TAG_YARD_LIST } from '../../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getYardList: builder.query({
      query: () => ({
        url: '/api/v1/core/yard',
        method: 'GET',
      }),
      providesTags: [CACHE_TAG_YARD_LIST],
    }),
    getYardDetails: builder.query({
      query: ({ id }) => ({
        url: `/api/v1/core/yard/${id}`,
        method: 'GET',
      }),
      providesTags: [CACHE_TAG_YARD_LIST],
    }),
    createYard: builder.mutation({
      query: body => ({
        url: '/api/v1/core/yard',
        method: 'POST',
        body,
      }),
      invalidatesTags: [CACHE_TAG_YARD_LIST],
    }),
    updateYard: builder.mutation({
      query: body => ({
        url: `/api/v1/core/yard/${body.id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [CACHE_TAG_YARD_LIST],
    }),
    patchYard: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/api/v1/core/yard/${id}`,
        method: 'PATCH',
        body: { ...rest },
      }),
      invalidatesTags: [CACHE_TAG_YARD_LIST],
    }),
    deleteYard: builder.mutation({
      query: ({ id }) => ({
        url: `/api/v1/core/yard/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CACHE_TAG_YARD_LIST],
    }),
  }),
})

export const {
  useGetYardListQuery,
  useLazyGetYardListQuery,
  useLazyGetYardDetailsQuery,
  useCreateYardMutation,
  useUpdateYardMutation,
  usePatchYardMutation,
  useDeleteYardMutation,
} = extendedApi
